import { RootState } from '../index';
export const getThemeColor = (state: RootState) => {
  return state.interface.themeColor;
};
